import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import {
  paddingLeft,
  paddingRight,
} from '@/utils/directions';
import { useChainContext } from '../../../context/context';

const ChatField = ({ onSendMessage, ChatId }) => {
  const [NewMessage, setNewMessage] = useState('');
  const { socket } = useChainContext();

  const handleSendMessage = () => {
    if (NewMessage.trim() !== '') {
      onSendMessage(NewMessage);
      setNewMessage('');
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSendMessage();
    } else {
      handleTyping();
    }
  };

  const handleTyping = () => {
    if (socket && ChatId) {
      socket.emit('typingStatus', {
        chatId: ChatId,
        userId: JSON.parse(localStorage.getItem('user')).data.user.user_id,
      });
    }
  };

  return (
    <ChatTextField>
      <ChatForm>
        <ChatFieldInput
          type="text"
          name="chatField"
          placeholder="Type message..."
          value={NewMessage}
          onChange={e => setNewMessage(e.target.value)}
          // onFocus={() => setEmojiPickerVisible(false)}
          onKeyPress={handleKeyPress}
        />
        <SendButton
          type="button"
          onClick={handleSendMessage}
          disabled={!NewMessage.trim()}
        >
          Send
        </SendButton>
      </ChatForm>
    </ChatTextField>
  );
};

export default ChatField;


// region STYLES
const StyledEmojiPicke = styled.div`
  position: absolute;
  top: -15px; /* Adjust the top position as needed */
  right: 0; /* Position it at the top right corner */
`;
// const StyledEmojiPicker = styled(EmojiPicker)`
//   width: 250px; /* Set your desired width */
//   height: 350px; /* Set your desired height */


// `;
const ChatTextField = styled.div`
  width: 100%;
  border-top: 1px solid #1f2937;
  padding: 10px 14px;
`;

const ChatForm = styled.form`
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
`;

const ChatFieldInput = styled(Form.Control)`
  flex: 1;
  height: 48px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  transition: 0.2s;
  ${paddingLeft}: 16px;
  ${paddingRight}: 16px;
  background-color: rgba(15, 23, 42, 0.6);
  border: 1px solid #1f2937;
  color: #ffffff;

  &::placeholder {
    color: #94a3b8;
  }

  &:focus, &:hover, &:active {
    border-color: #1f2937;
    outline: none;
    box-shadow: none;
    background-color: rgba(15, 23, 42, 0.8);
    color: #ffffff;
  }
`;

const SendButton = styled.button`
  height: 48px;
  padding: 0 24px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(90deg, #5ce9ff, #00f7d2);
  color: #001018;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 247, 210, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// endregion
